// Prevent scroll/jump on mailto-cta buttons (capture phase, block a11y.js focusHash)
document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(e) {
        const target = e.target.closest('a.mailto-cta');
        if (target) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.location.href = target.href;
        }
    }, true); // use capture phase
});
// ----------------------------------------------------------------------------
// Application JavaScript
// ----------------------------------------------------------------------------
//
// All scripts are loaded to the project through this master script sheet,
// which bundles our code via Webpack.
//
// Includes are listed alphabetically for easiest identification.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './libs/feature-detect'; // Feature Detection
import './libs/a11y';           // Accessibility
import './libs/spritesheet';    // Spritesheet
import './libs/just-validate';  // Just-Validate
// import './libs/webfonts';       // Web Fonts (optional)

// -------------------------------------
// Global Helpers
// -------------------------------------
import './helpers/external-links'; // Open external links in new tab

// -------------------------------------
// Load Base Styles
// -------------------------------------

// Global Styles
import 'normalize.css/normalize.css';
import 'styles/base/helpers.scss';
import 'styles/base/html-tags.scss';
import 'styles/base/layout.scss';
import 'styles/base/placeholders.scss';

// Button Styles
import 'styles/base/button/button.scss';
import 'styles/base/button/button--text.scss';
import 'styles/base/button/button--transparent.scss';

// Animations
import 'styles/base/animations/animations';

// Specialty Styles
// TODO: these should probably move?
import 'styles/base/product.scss';
import 'styles/base/carousel.scss';
import 'styles/base/_forms.scss';


// -------------------------------------
// Load Snippets
// -------------------------------------
import 'snippets/toggletip/toggletip';

// -------------------------------------
// Load Sections
// -------------------------------------

import {load} from '@shopify/theme-sections';

document.addEventListener('DOMContentLoaded', () => {
    load('*');
});


// -------------------------------------
// Load Templates
// -------------------------------------

import 'templates/404/404';
import 'templates/article/article';
import 'templates/blog/blog';
import 'templates/cart/cart';
import 'templates/collections/collection';
import 'templates/gift-card/gift_card';
import 'templates/index/index';
import 'templates/pages/pages';
import 'templates/products/product';
import 'templates/search/search';
import 'templates/customers/account/account';
import 'templates/customers/addresses/addresses';
import 'templates/customers/login/login';
import 'templates/customers/order/order';
import 'templates/password/password';
// TODO: how should we include activate_account, register and reset_password template
